export enum QuestionIllustration
{
    // USA
    StatueOfLiberty,
    MountRushmore,
    Washington,
    // Japan
    Sushi,
    Sumo,
    Tokyo,
    SumoTokyo,
    MountFuji,
    // Egypt
    Pyramids,
    Mummies,
    Camels,
    Sphinx,
    // Australia
    SydneyOperaHouse,
    Animals,
    GoldCoast,
    // Canada
    IceHockey,
    Toronto,
    Moose,
    //France
    EiffelTower,
    MonoLisa,
    NotraDame,
    // UK
    TowerOfLondon,
    WindsorCastle,
    LondonBus,
    BigBen,
    Stonehenge,
    WhiteCliffsOfDover,
    RoyalGuards,
    Blackpool,
    HadriansWall,
    Flag,
}